/* eslint-disable import/prefer-default-export */

// An array of item statuses for which loan due date cannot
// be changed
export const DueDateUnchangeableItemStatuses = [
  'Declared lost',
  'Claimed returned',
  'Aged to lost'
];

export const RequestCancelledStatus = 'Closed - Cancelled';
